import React from 'react';
//Material-UI
import { Checkbox, Button } from '@material-ui/core';
//Context
import { useProductos } from './ProductosContext';

export default function LineasList() {
    const {
        lines,
        isProdSelected,
        selectedLine,
        selectedIndex,
        handleListLinesClick,
        handleToggle,
        checked,
        cnlLines,
        isSaveLines,
        saveLines,
    } = useProductos();

    return (
        <div className="productos-panel-lines">
            <div className="productos-card">
                <div className="productos-card-toolbar">
                    <h3 className="productos-card-title">Líneas</h3>
                </div>
                {isProdSelected ? (
                    <div className="productos-empty">
                        Selecciona un producto para ver sus líneas
                    </div>
                ) : (
                    <div key={selectedIndex} className="productos-lines-animate">
                        <div className="productos-lines-list">
                            {lines.map((item) => (
                                <div
                                    key={item.id}
                                    className={`productos-line-item${selectedLine === item.id ? ' productos-line-item--selected' : ''}`}
                                    onClick={(e) => handleListLinesClick(e, item.id)}
                                >
                                    <Checkbox
                                        edge="start"
                                        color="primary"
                                        size="small"
                                        onChange={handleToggle(item.id - 1)}
                                        checked={checked.indexOf(item.id - 1) !== -1}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <span className="productos-line-name">{item.nombre}</span>
                                </div>
                            ))}
                        </div>
                        <div className="productos-panel-footer">
                            <Button
                                variant="outlined"
                                className="productos-btn"
                                disabled={isSaveLines}
                                onClick={cnlLines}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                className="productos-btn"
                                disabled={isSaveLines}
                                onClick={saveLines}
                            >
                                Guardar
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
